import { lazy } from 'react'
import __Layout from './Layout'

const Dashboard = lazy(() => import('./pages/Dashboard'))
const Users = lazy(() => import('./pages/Users'))
const LiveSessions = lazy(() => import('./pages/LiveSessions'))
const Categories = lazy(() => import('./pages/Categories'))
const ContentLibrary = lazy(() => import('./pages/ContentLibrary'))
const Courses = lazy(() => import('./pages/Courses'))
const Lessons = lazy(() => import('./pages/Lessons'))
const Purchases = lazy(() => import('./pages/Purchases'))
const Campaigns = lazy(() => import('./pages/Campaigns'))
const Donations = lazy(() => import('./pages/Donations'))
const PushNotifications = lazy(() => import('./pages/PushNotifications'))
const Certificates = lazy(() => import('./pages/Certificates'))
const MessageLogs = lazy(() => import('./pages/MessageLogs'))
const WhatsappTemplates = lazy(() => import('./pages/WhatsappTemplates'))
const AdminManagement = lazy(() => import('./pages/AdminManagement'))
const UserDetails = lazy(() => import('./pages/UserDetails'))
const EmailTemplates = lazy(() => import('./pages/EmailTemplates'))
const MembershipManagement = lazy(() => import('./pages/MembershipManagement'))
const ZoomSettings = lazy(() => import('./pages/ZoomSettings'))
const PaymentTransactions = lazy(() => import('./pages/PaymentTransactions'))
const InvoicesBillingExplorer = lazy(
  () => import('./pages/InvoicesBillingExplorer'),
)
const SadhanaManagement = lazy(() => import('./pages/SadhanaManagement'))
const HomeCarouselManagement = lazy(
  () => import('./pages/HomeCarouselManagement'),
)
const ReceiptSettings = lazy(() => import('./pages/ReceiptSettings'))

export const PAGES = {
  Dashboard: Dashboard,
  Users: Users,
  LiveSessions: LiveSessions,
  Categories: Categories,
  ContentLibrary: ContentLibrary,
  Courses: Courses,
  Lessons: Lessons,
  Purchases: Purchases,
  Campaigns: Campaigns,
  Donations: Donations,
  PushNotifications: PushNotifications,
  Certificates: Certificates,
  MessageLogs: MessageLogs,
  WhatsappTemplates: WhatsappTemplates,
  AdminManagement: AdminManagement,
  UserDetails: UserDetails,
  EmailTemplates: EmailTemplates,
  MembershipManagement: MembershipManagement,
  ZoomSettings: ZoomSettings,
  PaymentTransactions: PaymentTransactions,
  InvoicesBillingExplorer: InvoicesBillingExplorer,
  SadhanaManagement: SadhanaManagement,
  HomeCarouselManagement: HomeCarouselManagement,
  ReceiptSettings: ReceiptSettings,
}

export const pagesConfig = {
  mainPage: 'Dashboard',
  Pages: PAGES,
  Layout: __Layout,
}
